import React, { useState } from "react";
import { MdBloodtype, MdAccessibility } from "react-icons/md";
import { GiDna2, GiBrain, GiHearts } from "react-icons/gi";
import { RiAddBoxFill } from "react-icons/ri";
import { AiOutlineDelete, AiOutlineArrowRight } from "react-icons/ai";
import { Tabs, Text, Card, Avatar, SimpleGrid } from "@mantine/core";
import { forwardRef } from "react";

const EHR = () => {
  const patient = {
    name: "Mr. Jesse E.",
    age: 22,
    gender: "Male",
    allergies: "Anticonvulsants, Penincillin",
    avatar:
      "https://images.unsplash.com/photo-1611695434398-4f4b330623e6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80",
    concern: {
      description: "Joint pain on left knee",
      symptoms: "Joint redness, swelling, limping",
      medication: "Ibuprofen, Diclofenac, Duloxetine",
    },
  };

  return (
    <div className="Home" style={{ padding: "100px 8vw 15px 8vw" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Card shadow="sm" padding="lg" style={{ width: "25%", margin: 10 }}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Avatar src={patient.avatar} radius="100px" size="xl" />
            <div style={{ margin: 20 }}>
              <Text color="dimmed" weight={600} size="lg">
                {patient.name}
              </Text>
              <Text color="dimmed" weight={300} size="md">
                {patient.gender}, {patient.age}
              </Text>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text
              color="dimmed"
              weight={500}
              style={{ marginTop: 10, width: "100%" }}
            >
              Blood Group
            </Text>
            <Text color="dimmed" weight={300} style={{ width: "100%" }}>
              O+
            </Text>
            <Text
              color="dimmed"
              weight={500}
              style={{ marginTop: 10, width: "100%" }}
            >
              Height
            </Text>
            <Text color="dimmed" weight={300} style={{ width: "100%" }}>
              178 CM
            </Text>
            <Text
              color="dimmed"
              weight={500}
              style={{ marginTop: 10, width: "100%" }}
            >
              Weight
            </Text>
            <Text color="dimmed" weight={300} style={{ width: "100%" }}>
              72 KG
            </Text>
            <Text
              color="dimmed"
              weight={500}
              style={{ marginTop: 10, width: "100%" }}
            >
              Systolic Blood Pressure
            </Text>
            <Text color="dimmed" weight={300} style={{ width: "100%" }}>
              110
            </Text>
          </div>
        </Card>
        <Card shadow="sm" padding="lg" style={{ width: "75%", margin: 10 }}>
          <Tabs variant="pills">
            <Tabs.Tab label="OVERVIEW">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Card
                  shadow="sm"
                  padding="lg"
                  style={{ width: "50%", margin: 10 }}
                >
                  <iframe
                    title="malecardiovascular"
                    style={{ marginTop: 40 }}
                    id="embeddedHuman"
                    frameBorder="0"
                    width="100%"
                    height="600"
                    allowFullScreen={true}
                    src="https://human.biodigital.com/widget/?m=production/maleAdult/male_system_cardiovascular_15_high_def&amp;ui-tools=true&amp;uaid=f7n"
                  ></iframe>
                </Card>
                <Card
                  shadow="sm"
                  padding="ls"
                  style={{ width: "50%", margin: 10 }}
                >
                  <h4 style={{ padding: 20 }}>REPORTS</h4>
                  <SimpleGrid cols={2} spacing="lg">
                    <div
                      style={{
                        margin: 10,
                        padding: 20,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "#f1f1f1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <MdBloodtype size={26} color="red" />
                        <Text
                          color="dimmed"
                          weight={300}
                          size="sm"
                          align="right"
                        >
                          12.2
                        </Text>
                      </div>

                      <Text
                        color="dimmed"
                        weight={500}
                        size="lg"
                        style={{ margin: 10 }}
                      >
                        Blood Test
                      </Text>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
                          radius="lg"
                          size="sm"
                          style={{ margin: 5 }}
                        />
                        <Text color="dimmed" weight={300} size="sm">
                          Dr. Max Rodríguez
                        </Text>
                      </div>
                    </div>

                    <div
                      style={{
                        margin: 10,
                        padding: 20,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "#f1f1f1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <MdAccessibility size={26} color="turquoise" />
                        <Text
                          color="dimmed"
                          weight={300}
                          size="sm"
                          align="right"
                        >
                          14.2
                        </Text>
                      </div>

                      <Text
                        color="dimmed"
                        weight={500}
                        size="lg"
                        style={{ margin: 10 }}
                      >
                        Chest X-Ray
                      </Text>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
                          radius="lg"
                          size="sm"
                          style={{ margin: 5 }}
                        />
                        <Text color="dimmed" weight={300} size="sm">
                          Dr. Max Rodríguez
                        </Text>
                      </div>
                    </div>

                    <div
                      style={{
                        margin: 10,
                        padding: 20,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "#f1f1f1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <GiDna2 size={26} color="green" />
                        <Text
                          color="dimmed"
                          weight={300}
                          size="sm"
                          align="right"
                        >
                          16.2
                        </Text>
                      </div>
                      <Text
                        color="dimmed"
                        weight={500}
                        size="lg"
                        style={{ margin: 10 }}
                      >
                        C-Reactive Protein Test
                      </Text>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                          radius="lg"
                          size="sm"
                          style={{ margin: 5 }}
                        />
                        <Text color="dimmed" weight={300} size="sm">
                          Dr. Quintana Kerin
                        </Text>
                      </div>
                    </div>

                    <div
                      style={{
                        margin: 10,
                        padding: 20,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "#f1f1f1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <GiBrain size={26} color="pink" />
                        <Text
                          color="dimmed"
                          weight={300}
                          size="sm"
                          align="right"
                        >
                          16.2
                        </Text>
                      </div>
                      <Text
                        color="dimmed"
                        weight={500}
                        size="lg"
                        style={{ margin: 10 }}
                      >
                        EEG Report
                      </Text>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          src="https://images.unsplash.com/photo-1537368910025-700350fe46c7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
                          radius="lg"
                          size="sm"
                          style={{ margin: 5 }}
                        />
                        <Text color="dimmed" weight={300} size="sm">
                          Dr. Francesco Jamson
                        </Text>
                      </div>
                    </div>

                    <div
                      style={{
                        margin: 10,
                        padding: 20,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "#f1f1f1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <GiHearts size={26} color="red" />
                        <Text
                          color="dimmed"
                          weight={300}
                          size="sm"
                          align="right"
                        >
                          17.2
                        </Text>
                      </div>
                      <Text
                        color="dimmed"
                        weight={500}
                        size="lg"
                        style={{ margin: 10 }}
                      >
                        ECG
                      </Text>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                          radius="lg"
                          size="sm"
                          style={{ margin: 5 }}
                        />
                        <Text color="dimmed" weight={300} size="sm">
                          Dr. Carol Miller
                        </Text>
                      </div>
                    </div>
                  </SimpleGrid>
                </Card>
              </div>
            </Tabs.Tab>
            <Tabs.Tab label="VITALS"></Tabs.Tab>
            <Tabs.Tab label="DIAGNOSTICS"></Tabs.Tab>
            <Tabs.Tab label="LAB REPORTS"></Tabs.Tab>
            <Tabs.Tab label="IMAGING"></Tabs.Tab>
            <Tabs.Tab label="NOTES"></Tabs.Tab>
          </Tabs>
        </Card>
      </div>
    </div>
  );
};

export default EHR;
